// An enum to keep the 3 prechat message animations
const PreChatMessageAnimations = {
    First: 'apexchat_prechat_first_msg', //
    Upcoming: 'apexchat_prechat_upcoming_msg', //
    Previous: 'apexchat_prechat_prev_msg', //
    FadeOut: 'apexchat_prechat_fade_out' //
};
export default PreChatMessageAnimations;
